/* eslint-disable  react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import GetAppIcon from "@mui/icons-material/GetApp";
import Grid from "@mui/material/Grid";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import BarcodeReader from "react-barcode-reader";
import { useTranslation } from "react-i18next";
import PDialog from "../../../components/pos/PDialog";

import FileUploadIcon from "@mui/icons-material/FileUpload";
import API from "../../../utils/API";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function ProductList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(getColumns());
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 345) / 28)
  );

  let lastSearch = null;

  const options = {
    searchAlwaysOpen: true,
    serverSide: true,
    viewColumns: false,
    filter: false,
    download: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 280,
    rowsPerPage: Math.round((getWindowDimensions().height - 345) / 28),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 345) / 28),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
  };
  const [option, setOption] = useState(options);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    console.log("lastSearch", lastSearch);

    if (lastSearch) {
      loadByRest(
        lastSearch.curPage,
        lastSearch.pageSize,
        lastSearch.sort,
        lastSearch.filter
      );
      return;
    }
    let sort = [];
    sort.push({ id: "name", sortOrder: "ASC" });

    let filter = {
      and: [{ op: "eq", key: "productType", value: props.productType }],
      or: [],
    };

    loadByRest(
      0,
      rowLimitPerPage,
      JSON.stringify(sort),
      JSON.stringify(filter)
    );
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);

    lastSearch = {
      curPage: curPage,
      pageSize: pageSize,
      sort: sort,
      filter: filter,
    };

    let result = {};
    let excludeList = [];

    result = await API.get(
      "/e_api/v1/products?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    const opt = { ...option };
    opt.count = parseInt(result.data.meta.total);
    setOption(opt);
    setData(result.data.data);

    setIsLoading(false);
  }

  async function onBarcodeScanned(barcode) {
    console.log("Barcode Scanned" + barcode);

    let filter = {
      and: [
        { op: "eq", key: "productType", value: props.productType },
        { op: "eq", key: "barcode", value: barcode },
      ],
      or: [],
    };

    loadByRest(0, rowLimitPerPage, "[]", JSON.stringify(filter));
  }

  function rejectdBarcode(barcode) {}

  async function onTableChange(tableState) {
    console.log(tableState);
    let sort = [];
    sort.push({ id: "name", sortOrder: "ASC" });
    let search = { and: [], or: [] };
    if (tableState.sortOrder.name) {
      sort = [];
      sort.push({
        id: tableState.sortOrder.name,
        sortOrder: tableState.sortOrder.direction === "desc" ? "DESC" : "ASC",
      });
    }

    search.and.push({ op: "eq", key: "productType", value: props.productType });

    if (tableState.searchText) {
      search.or.push({
        op: "contains",
        key: "code",
        value: tableState.searchText,
      });
      search.or.push({
        op: "contains",
        key: "name",
        value: tableState.searchText,
      });
      search.or.push({
        op: "contains",
        key: "barcode",
        value: tableState.searchText,
      });
    }
    loadByRest(
      tableState.page,
      rowLimitPerPage,
      JSON.stringify(sort),
      JSON.stringify(search)
    );
  }

  function getColumns() {
    return [
      {
        name: "store",
        label: translate("Store"),
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "name",
        label: translate("Name"),
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "code",
        label: translate("Code"),
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "price",
        label: translate("Price"),
        options: {
          filter: false,
          sort: true,
        },
      },

      {
        name: "stock",
        label: translate("stock"),
        options: {
          filter: false,
          sort: true,
        },
      },
    ];
  }

  function getTitle() {
    if (props.productType == "R") {
      return "Restaurant Items List";
    }
    return props.context.appType === "R_POS"
      ? translate("Inventory Items List")
      : translate("Product List");
  }

  function onCloseWindow() {
    props.setShowProductSearch(false);
  }
  let content = (
    <Grid container>
      <BarcodeReader
        onError={rejectdBarcode}
        onScan={onBarcodeScanned}
        preventDefault={true}
        avgTimeByChar={
          props.context.storeAdmin.barcodeScanAvgTimeByChar
            ? props.context.storeAdmin.barcodeScanAvgTimeByChar
            : 30
        }
      ></BarcodeReader>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {getTitle()}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
    </Grid>
  );

  return (
    <div>
      <PDialog
        content={content}
        title={translate("Product lookup")}
        onCloseWindow={onCloseWindow}
        maxWidth={"lg"}
        fullWidth={true}
        open={true}
        hideSave={true}
      ></PDialog>
    </div>
  );
}
